<template>
    <div class="layout-device-list">
        <!--s: Search 区域-->
        <div class="device-list-search">
            <div class="device-list-select">
                <div class="box">
                    <div class="box-list">
                        <span class="label">查找：</span>
                        <Input prefix="ios-search" v-model="modelListParams.name" placeholder="模型名称" style="width: 230px" />
                    </div>
                    <div class="box-list">
                        <Button @click="onReset">重置</Button>
                        <Button type="primary" @click="onSearch">查询</Button>
                    </div>
                </div>
                <div class="box">
                    <Button icon="ios-redo-outline" @click="onBatchDownLoad('batch')">批量导出</Button>
                    <Button type="primary" icon="ios-add" @click="onAddModel">新增</Button>
                </div>
            </div>
        </div>
        <!--e: Search 区域-->
        <!--s: Data 区域-->
        <div class="device-list">
            <div class="business-list-box">
                <Table :loading="modelLoading" :height="modelHeight" stripe="stripe" :columns="modelListColumns" :data="modelListArray.content" @on-select-all="onSelectAll" @on-select-all-cancel="onSelectAllCancel" @on-select="onSelect" @on-select-cancel="onSelectCancel">
                    <template slot="序号" slot-scope="{ index }">
                        {{ index+1 }}
                    </template>
                    <template slot="模型名称" slot-scope="{ row }">
                       {{ row.name }}
                    </template>
                    <template slot="模型标签" slot-scope="{ row }">
                        <Poptip trigger="hover" placement="bottom-start">
                            <div class="tag"><font class="blue" :key="key" v-for="(tag,key) in row.tagList">{{ tag }}{{ key !== row.tagList.length-1?'/':''}}</font></div>
                            <template #content>
                                <div class="tag-list" :key="key" v-for="(tag,key) in row.tagList">{{ tag }}</div>
                            </template>
                        </Poptip>
                    </template>
                    <template slot="更新时间" slot-scope="{ row }">
                        {{ row.updateTime?row.updateTime.replace(/:..$/, '') : '/'}}
                    </template>
                    <template slot="解析状态" slot-scope="{ row }">
                        <font class="green" v-if="row.status === 2">已完成</font>
                        <font class="black" v-if="row.status === 0">待解析</font>
                        <font class="blue" v-if="row.status === 1">解析中</font>
                        <font class="red" v-if="row.status === 3">解析失败</font>
                    </template>
                    <template slot="操作" slot-scope="{ row }">
                        <div class="handle">
                            <a href="javascript:" @click="onEditList(row)">编辑</a>
                            <a href="javascript:" v-if="row.useNum === 0" @click="onFileDelete(row.id)">删除</a>
                            <a href="javascript:" @click="onDownLoadFile(row)">导出</a>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="device-list-page" v-if="modelListArray.content && modelListArray.content.length !== 0">
                <Page :total="modelListArray.totalSize" :current="modelListParams.currentPage" show-total show-sizer size="small" :page-size="modelListParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
            </div>
        </div>
        <!--e: Data 区域-->

        <Modal
            v-model="modelModalVisible"
            :title="btnStatus?'新增模型':'编辑模型'"
            footer-hide>
            <div class="device-modal">
                <span class="label">模型名称：</span>
                <Input v-model="modelEditParams.name" placeholder="请输入" style="width: 300px" />
            </div>
            <div class="device-modal">
                <span class="label">上传模型：</span>
                <div class="model-upload">
                    <div class="upload-click" v-if="!speedVisible">
                        <div class="box">
                            <a href="javascript:" @click="choiceImg"><Icon type="ios-add" size="25"/></a>
                            <span class="text">上传文件</span>
                        </div>
                    </div>
                    <div class="upload-speed" v-if="speedVisible">
                        <div class="progress-info">
                            <div class="info-li">
                                <span class="name">{{ fileName }}</span>
                                <span class="size">{{ completeAsync === 100?'上传完成':'请稍后...' }}</span>
                            </div>
                        </div>
                        <div class="progress-box">
                            <div class="progress-outer">
                                <div class="progress-inner">
                                    <div class="progress-bg" :class="completeAsync<100?'before':''" :style="'width: '+completeAsync+'%; height: 10px;'"></div>
                                </div>
                                <div class="progress-text">{{ completeAsync }}%</div>
                            </div>
                        </div>
                    </div>
                    <input type="file" ref="model" multiple="multiple" class="file" @change="onFileDataChange($event)">
                    <a href="javascript:" class="again-upload" v-if="speedVisible && completeAsync === 100 && modelEditParams.useNum === 0" @click="choiceImg"><Icon type="md-refresh" size="20"/> 重新上传</a>
                </div>
            </div>
            <div class="device-footer">
                <Button @click="modelModalVisible = false;">取 消</Button>
                <Button :disabled="modelEditParams.filePath === '' || completeAsync!==100" type="primary" :loading="editLoading" @click="onSubmitCheck">确 定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import Model from './model'
export default Model
</script>
<style lang="less">
@import "model";
</style>
